import { render, staticRenderFns } from "./WaitingTimeAnimation.vue?vue&type=template&id=118b2928&scoped=true&"
import script from "./WaitingTimeAnimation.vue?vue&type=script&lang=js&"
export * from "./WaitingTimeAnimation.vue?vue&type=script&lang=js&"
import style0 from "./WaitingTimeAnimation.vue?vue&type=style&index=0&id=118b2928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b2928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
